import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogComment } from '../../../../models/projects/operation.models';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
})

export class CommentComponent implements OnInit {
  @Input() oldComment: LogComment;
  @Input() disabled: boolean;
  @Input() appearance: 'compact' | 'standalone' = 'compact';
  @Output() commentChange = new EventEmitter();

  commentEditor: LogComment = new LogComment();

  constructor() {
  }

  ngOnInit() {
    if (!!this.oldComment) {
      this.commentEditor = this.oldComment;
    }

    if (this.commentEditor.milestone == null) {
      this.commentEditor.milestone = false;
    }
  }

  commentChanged() {
    this.commentChange.emit(this.commentEditor);
  }


}



// WEBPACK FOOTER //
// ./src/pages/shared/components/comment/comment.component.ts